var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142.8 104.6",
    style: {
      enableBackground: "new 0 0 142.8 104.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFF2E1;}\r\n\t.st1{fill:none;stroke:#FFA200;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st2{fill:#231F20;}\r\n\t.st3{fill:#FAA21B;}\r\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.4,0h130c3.5,0,6.4,2.9,6.4,6.4v91.8c0,3.5-2.9,6.4-6.4,6.4H6.4c-3.5,0-6.4-2.9-6.4-6.4V6.4 C0,2.9,2.9,0,6.4,0z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "19.4,77.9 19.4,26.8 43.8,51.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "74.5,77.8 74.5,26.6 50.1,47.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M90.2,73.9c-2.3-1.3-4.1-3.2-5.4-5.5c-1.4-2.5-2-5.4-2-8.2c-0.1-2.9,0.6-5.7,2-8.2c1.3-2.3,3.2-4.2,5.5-5.5 c4.9-2.5,10.6-2.5,15.5,0c2.3,1.2,4.2,3.1,5.5,5.4c1.4,2.5,2.1,5.3,2,8.2c0.1,2.9-0.7,5.7-2.1,8.2c-1.3,2.3-3.3,4.2-5.6,5.5 c-2.4,1.3-5.1,2-7.8,1.9C95.2,75.9,92.5,75.2,90.2,73.9z M102.9,70.2c1.6-0.9,2.9-2.2,3.8-3.8c1-1.9,1.5-4,1.5-6.2 c0.1-2.1-0.4-4.3-1.4-6.2c-0.9-1.6-2.2-2.9-3.8-3.8c-3.1-1.6-6.9-1.6-10,0c-1.6,0.9-2.8,2.2-3.7,3.8c-1,1.9-1.4,4-1.3,6.2 c-0.1,2.1,0.4,4.3,1.3,6.2c0.8,1.6,2.1,2.9,3.6,3.8c1.5,0.8,3.3,1.3,5,1.2C99.7,71.4,101.4,71,102.9,70.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 123.6,
    cy: 71.4,
    r: 3.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0b3fe06d5fe03a806756a0b490d76c98.svg";
export { ForwardRef as ReactComponent };